import { Profile, GetProfile$Response } from '@api/service';
import * as fromOwner from '../actions/owner.action';

export interface ProfileState {
  owner: GetProfile$Response;
  loaded: boolean;
  loading: boolean;
}

export const initialState: ProfileState = {
  owner: null,
  loaded: false,
  loading: false
};

export function reducer(state = initialState, action: fromOwner.ProfileAction): ProfileState {
  switch (action.type) {
    case fromOwner.GET_OWNER: {
      return { ...state, loading: true };
    }

    case fromOwner.GET_OWNER_SUCCESS:
      const owner = action.payload;
      return { ...state, loading: false, loaded: true, owner };
    case fromOwner.UPDATE_OWNER_SUCCESS:
    case fromOwner.UPDATE_OWNER_WEIGHT_SUCCESS:
    case fromOwner.UPDATE_OWNER_EXERCISE_SUCCESS: {
      const profile = action.payload;
      const updatedOwner = { ...state.owner, profile };
      return { ...state, loading: false, loaded: true, owner: updatedOwner };
    }

    case fromOwner.GET_OWNER_FAIL: {
      return { ...state, loading: false, loaded: false };
    }
  }

  return state;
}

export const getOwnerLoading = (state: ProfileState) => state.loading;
export const getOwnerLoaded = (state: ProfileState) => state.loaded;
export const getOwner = (state: ProfileState) => state.owner;
